import { CdkScrollable } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { EscapeDialogDirective } from '../../directives/escape-dialog.directive';
import { DialogData } from '../../model/dialogData.model';
import { AbstractDynamicDialogComponent } from './abstract-dynamic-dialog.component';

@Component({
  selector: 'app-dynamic-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    EscapeDialogDirective,
    MatButtonModule,
    CdkScrollable,
    MatDividerModule
  ],
  template: ` <div [appEscapeDialog]="dialogRef">
    @if (data?.title) {
      <div [ngClass]="{ 'pb-20': !data?.displayClose }" mat-dialog-title>
        <div class="flex items-center justify-between h-48">
          <h6>{{ data.title }}</h6>
          @if (data?.displayClose !== false) {
            <button matIconButton aria-label="Close" mat-dialog-close>
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>
    }

    @if (data?.title) {
      <mat-divider class="mx-20!" />
    }

    <mat-dialog-content>
      <ng-container #content />
    </mat-dialog-content>

    <mat-divider class="mx-20!" />

    <mat-dialog-actions>
      @if (data?.displayCancel ?? true) {
        <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
      }
      @if (data.thirdButtonLabel) {
        <button
          (click)="componentRef?.instance?.extraAction()"
          [disabled]="componentRef?.instance?.thirdButtonDisable()"
          matButton="elevated"
          class="red-button">
          {{ data?.thirdButtonLabel }}
        </button>
      }
      <button
        [ngClass]="{ 'ml-auto': !data?.displayCancel && !data?.thirdButtonLabel }"
        (click)="componentRef?.instance?.saveOrExecuteAction()"
        [disabled]="componentRef?.instance?.form?.invalid || componentRef?.instance?.disabled()"
        matButton="elevated"
        class="red-button">
        {{ data?.action || 'SAVE' }}
      </button>
    </mat-dialog-actions>
  </div>`
})
export class DynamicDialogComponent implements OnInit, OnDestroy {
  @ViewChild('content', { read: ViewContainerRef, static: true }) vcRef: ViewContainerRef;
  @ViewChild(EscapeDialogDirective) escapeDialogDirective: EscapeDialogDirective;
  data: DialogData = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<DynamicDialogComponent>);
  private cd = inject(ChangeDetectorRef);
  componentRef: ComponentRef<AbstractDynamicDialogComponent>;

  ngOnInit(): void {
    this.vcRef.clear();
    this.componentRef = this.vcRef.createComponent(this.data.component);
    this.cd.detectChanges();
    this.dialogRef.afterClosed().subscribe(() => this.componentRef.instance.disabled.set(false));
  }

  ngOnDestroy() {
    this.componentRef?.destroy();
  }
}
